/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import { postTypes, heirarchalPostTypes } from '@/lib/wp/postTypes';

export const seoSocialPropTypes = {
  social: PropTypes.shape({
    facebook: PropTypes.string,
    instagram: PropTypes.string,
    linkedIn: PropTypes.string,
    mySpace: PropTypes.string,
    pinterest: PropTypes.string,
    twitter: PropTypes.string,
    wikipedia: PropTypes.string,
    youTube: PropTypes.string,
  }),
};

export const seoPropTypes = {
  seo: PropTypes.shape({
    breadcrumbs: PropTypes.array,
    canonical: PropTypes.string,
    description: PropTypes.string,
    metaRobotsIndex: PropTypes.string,
    metaRobotsFollow: PropTypes.string,
    opengraphAuthor: PropTypes.string,
    opengraphModifiedTime: PropTypes.string,
    opengraphPublishedTime: PropTypes.string,
    opengraphImage: PropTypes.shape({
      altText: PropTypes.string,
      sourceUrl: PropTypes.string,
    }),
    siteTitle: PropTypes.string,
    siteDescription: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
    ...seoSocialPropTypes,
  }),
};

export const postPropTypes = {
  post: PropTypes.shape({
    author: PropTypes.object,
    blocks: PropTypes.array,
    databaseId: PropTypes.number,
    date: PropTypes.string,
    excerpt: PropTypes.string,
    featuredImage: PropTypes.object,
    ...seoPropTypes,
    slug: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    uri: PropTypes.string,
  }),
};

export const archivePropTypes = {
  archive: PropTypes.bool,
  posts: PropTypes.array,
  pagination: PropTypes.shape({
    endCursor: PropTypes.string,
    hasNextPage: PropTypes.bool,
    hasPreviousPage: PropTypes.bool,
    startCursor: PropTypes.string,
  }),
};

/**
 * Retrieve basic prop types for a given page.
 *
 * @param  {string} postType WP post type.
 * @return {object}          Page prop types.
 */
export default function getPagePropTypes(postType) {
  if (!Object.keys(postTypes).includes(postType)) {
    return null;
  }

  const hasArchive = !heirarchalPostTypes.includes(postType);

  return {
    ...postPropTypes,
    ...(hasArchive && archivePropTypes),
  };
}
